const disp = [
    {
        label: '全部状态',
        value: 0,
    },
    {
        label: '初审中',
        value: 1,
    },
    {
        label: '意见反馈中',
        value: 2,
    },
    {
        label: '已预披露',
        value: 3,
    },
    {
        label: '中止审查',
        value: 4,
    },
    {
        label: '终止审查',
        value: 5,
    },
    {
        label: '已过会',
        value: 6,
    },
    {
        label: '已核准',
        value: 7,
    },
];

export default disp;
